<script>
import urijs from "urijs";
export default {
  computed: {
    isope_nurlconfig() {
      if (this.$store.getters.getKey("isope_urlconfig") || this.$store.getters.getKey("isope_urlconfig") == 1) {
        return this.$store.getters.getKey("isope_urlconfig");
      } else {
        return 0
      }
    },
    url_item() {
      console.log(this.$store.state.appConfig.landing_config.configValue.url_item);
      return this.$store.state.appConfig.landing_config.configValue.url_item;
    },
    list() {
      if (this.$store.state.webUrls.web_landing_page_domain2) {
        let arr = (
          (this.$store.state.webUrls || {}).web_landing_page_domain2 || {}
        ).split(",");
        if (this.$store.getters.getKey('randomArray') == '1') {
          return arr = this.randomArray(arr).slice(0, 3)
        } else {
          return arr
        }

      } else {
        this.$store.dispatch("getWebUrls");
        return [];
      }
    },
  },
  methods: {
    open(url) {
      const currUrl = urijs(url);
      const protocol = currUrl.protocol();
      var isSafari = !/Chrome/.test(navigator.userAgent) && /Safari/.test(navigator.userAgent)
      if (protocol) {
        if (isSafari) {
          window.open(url, "_self");
        } else {
          window.open(url, "_blank”");
        }
      } else {
        if (isSafari) {
          window.open(`//${url}`, "_self");
        } else {
          window.open(`//${url}`, "_blank”");
        }

      }

    },
    randomArray(arr) {
      return [...arr].sort(function () {
        return (0.5 - Math.random());
      });
    },
    random(min, max) {
      return Math.floor(Math.random() * (max - min)) + min;
    },
  },
};
</script>
